import { Component } from '@angular/core';

@Component({
  selector: 'app-setting-super-admin',
  templateUrl: './setting-super-admin.component.html',
  styleUrls: ['./setting-super-admin.component.scss']
})
export class SettingSuperAdminComponent {

}
